import http from './http'

class Export {
  assignors () {
    return http.get('/export_assignors')
  }

  cnabFile (id) {
    return http.get(`/admin_back_office/export_cnab_file/${id}/download`)
  }

  assignmentRequestContract (id) {
    return http.get(`/admin_back_office/export_assignment_request_contract/${id}`)
  }
}

export default new Export()



// WEBPACK FOOTER //
// ./src/services/export.js